// store/Plans/PlansAction.js
import * as actionTypes from "../ActionTypes";

export const savePlanAction = (payload) => ({
  type: actionTypes.SAVE_PLAN_CHURCH_REQUEST,
  payload,
});

export const readPlanAction = (payload) => ({
  type: actionTypes.READ_PLAN_CHURCH_REQUEST,
  payload,
});

export const saveDayPlanAction = (payload) => ({
  type: actionTypes.SAVE_DAY_PLAN_REQUEST,
  payload,
});
